const dataRoadmap = [
    {
        id: 1,
        time: 'Conception Research',
        list: [
            {
                text: "We partner with our client's to  articulate their vision and define a clear concept. We research what thecnologies, team, and process are needed to execute that concept."
            },
        ],
        positon: 'left',
    },
    {
        id: 2,
        time: 'Strategy Design',
        list: [
            {
                text: "We develop a detailed overall design including creative direction, game mechanics, scripting detailed timelines on when to expect different aspects of the game."
            },
        ],
        positon: 'right',

    },
    {
        id: 3,
        time: 'MVP',
        list: [
            {
                text: "Build out a Minimum Viable Product (MVP) to start testing game mechanics. Getting user feedback as quickly as possible to guide further development"
            },
        ],
        positon: 'left'
    },
    {
        id: 4,
        time: 'Full Build',
        list: [
            {
                text: 'Once we have a game that players enjoy, we can start polishing the art and gameplay to bring the game to a market release.'
            },
        ],
        positon: 'right'
    },
    {
        id: 5,
        time: 'Product Release',
        list: [
            {
                text: "Support the client to design a release strategy to ensure a high chance of good launch traction."
            },
        ],
        positon: 'left'
    },
    {
        id: 6,
        time: 'On-going Support',
        list: [
            {
                text: "Post release support, optimization, advice, and safeguarding."
            },
        ],
        positon: 'right'
    },
]

export default dataRoadmap;